import { getConfig } from './config'

export interface UpdateUser {
  _id: string;
  name: string;
  occupation: string;
  phone: string;
  birthDate: Date;
  avatar: string;
}

export interface UserUpdateResponse {
  profile: string;
  status: string;
  isDeleted: boolean;
  _id: string;
  name: string;
  email: string;
  updatedAt: Date;
  createdAt: Date;
  gender: string;
  birthDate: Date;
  occupation: string;
  phone: string;
  accessCodeId: string;
  avatar?: string | null;
}

export const update = async ({ _id, ...restParams }: Partial<UpdateUser>): Promise<UserUpdateResponse> => {
  const config = getConfig()
  const response = await config.axios.put<UserUpdateResponse>(`${config.API_URL}/users/${_id}`, restParams)

  return response.data
}
